export default class FeatureGates {
    public static readonly PASSWORD_CREATE_SIF_FG= "PasswordCreateSIFControl";
}
